import { extend } from '@thd-nucleus/data-sources';

import { PromoPodDataModel } from './PromoPodDataModel';

export const CardCallToActionDataModel = extend(PromoPodDataModel);
